export const UPDATE_SELECTED_BATCH_CLAIMS = "UPDATE_SELECTED_BATCH_CLAIMS";

export function updateSelBatchClaims(claims) {
  return {
    type: UPDATE_SELECTED_BATCH_CLAIMS,
    payload: claims
  };
}



// WEBPACK FOOTER //
// ./src/app/submit_claims/recent_batch/actions.js